module.exports = __webpack_public_path__ + "img/logo.811dbe29.png";